import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  ApiGatewayService,
  DecryptedMessage,
  DMSDevice, RegisteredDevice,
} from "../../services/api-gateway.service";
import { DateTimeUtilsService } from 'src/app/services/date-time-utils.service';
import {emitInfoMessage, InfoMessageService} from "../../services/info-message.service";

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  standalone: false
})
export class MessagesComponent {

  constructor(
              public dateTimeUtils: DateTimeUtilsService,
              private infoMessageService: InfoMessageService,
              private gatewayApiService: ApiGatewayService,
  ) {
    this.getOrgDevices();
  };

  private _messages: DecryptedMessage[] | null = [];
  totalTemperature: number = 0;
  totalBatteryVoltage: number = 0;
  totalHumidity: number = 0;
  totalPressure: number = 0;
  messageCounter: number = 0

  @Input()
  set messages(value: DecryptedMessage[] | null) {
    this._messages = value;
    this.calculateTotals();
  }

  get messages(): DecryptedMessage[] | null {
    return this._messages;
  }

  dmsDevices: RegisteredDevice[] = [];
  selectedDeviceId: number | null = null;

  @Input() totalItems: number = 0;
  @Output() pageChange = new EventEmitter<{from: number, to: number}>();
  @Output() deviceFilterChange = new EventEmitter<number | null>();

  pageSize: number = 10;

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  paginate(page: number): void {
    const to = (page ) * this.pageSize + 1;
    const from = to - 10;
    this.pageChange.emit({from, to});
  }

  private calculateTotals(): void {
    this.totalTemperature = 0;
    this.totalBatteryVoltage = 0;
    this.totalHumidity = 0;
    this.totalPressure = 0;
    this.messageCounter = 0;
    if (this._messages) {
      for (const msg of this._messages) {
        if (msg.decoded_message) {
          msg.encodedMessage = JSON.parse(msg.decoded_message)
          msg.encodedMessage.VBat ??= msg.encodedMessage.BatteryVoltage
          this.messageCounter++
          this.totalTemperature += msg.encodedMessage.Temperature ?? 0;
          this.totalBatteryVoltage += msg.encodedMessage.VBat ?? 0;
          this.totalHumidity += msg.encodedMessage.Humidity ?? 0;
          this.totalPressure += msg.encodedMessage.Pressure ?? 0;
        }
      }
    }
    if(this.messageCounter > 0) {
      this.totalTemperature = Math.round((this.totalTemperature / this.messageCounter) * 10) / 10
      this.totalPressure = Math.round((this.totalPressure / this.messageCounter) * 10) / 10
      this.totalHumidity = Math.round((this.totalHumidity / this.messageCounter))
      this.totalBatteryVoltage = Math.round((this.totalBatteryVoltage / this.messageCounter) * 10) / 10
    }
  }

  async getOrgDevices(){
      await this.gatewayApiService.getRegisteredDevices().then((data) => {
        if (data.body) {
          this.dmsDevices = data.body.filter((x: RegisteredDevice) => x.devaddr.startsWith("03"))
        }
      })
      .catch((error) => {
        emitInfoMessage(error.status + ": " + error.statusText, this.infoMessageService)
      })
  }

  onDeviceChange(): void {
    this.deviceFilterChange.emit(this.selectedDeviceId);
  }

  public async downloadExport(): Promise<void> {
    try {
      const response = await this.gatewayApiService.getMessagesExport();

      if (response.body) {
        // Create blob URL
        const blob = response.body;
        const url = window.URL.createObjectURL(blob);

        // Extract filename from Content-Disposition header if available
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'messages.csv';
        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // Create temporary link and trigger download
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error downloading CSV export:', error);
    }
  }
}
